module.exports = __webpack_public_path__ + "img/gfwb.0c1dc965.png";